import * as z from "zod";
import { SchemaProceso } from "./Proceso.schema";
import { TextInput } from "@/components/Inputs/TextInput";
import { SelectInput } from "@/components/Inputs/SelectInput";
import type { SchemaFlujoEntidadIn } from "./Flujo.schema";
import { Button } from "@/components/ui/button";

interface FormProps<T> {
	readonly value: z.input<T>;
	readonly onChange: (d: SchemaFlujoEntidadIn) => void;
	readonly onAdd: (d: SchemaFlujoEntidadIn) => void;
	readonly errors: { [key in keyof z.input<T>]?: string[] };
}
export function FormProyectoProceso(props: FormProps<typeof SchemaProceso>) {
	const { value, onChange, errors } = props;
	const handler: ChangeHandler<typeof SchemaProceso> = (field, val) => {
		onChange({ ...value, [field]: val });
	};

	const handleEntrada = () => {
		const newEntrada: SchemaFlujoEntidadIn = {
			id: crypto.randomUUID(),
			nombre: "Nueva Entrada",
			tipo: "entrada",
			subtipo: "raw_co2",
			unidad: "g",
			cantidad: 0,
			idProyecto: value.id,
			idProcesoTo: null,
		};
		props.onAdd(newEntrada);
	};

	const handleSalida = () => {
		const newSalida: SchemaFlujoEntidadIn = {
			id: crypto.randomUUID(),
			nombre: "Nueva Salida",
			tipo: "salida",
			subtipo: "raw_co2",
			unidad: "g",
			cantidad: 0,
			idProyecto: value.id,
			idProcesoFrom: null,
		};
		props.onAdd(newSalida);
	};

	return (
		<form onSubmit={(e) => e.preventDefault()} className="space-y-4">
			<TextInput
				value={value.nombre}
				onChange={(e) => handler("nombre", e.target.value)}
				errors={errors.nombre}
				label="Nombre"
				placeholder="Nombre"
				type="text"
			/>
			<TextInput
				value={value.descripcion}
				onChange={(e) => handler("descripcion", e.target.value)}
				errors={errors.descripcion}
				label="Descripción"
				placeholder="Descripción"
				type="text"
			/>
			<TextInput
				value={value.referencia}
				onChange={(e) => handler("referencia", e.target.value)}
				errors={errors.referencia}
				label="Referencia"
				placeholder="Referencia"
				type="text"
			/>
			<SelectInput
				value={value.externo}
				onChange={(e) => handler("externo", e as "propio" | "externo")}
				errors={errors.externo}
				label="Tipo"
				// placeholder="Tipo"
				options={{
					propio: "Propio",
					externo: "Externo",
				}}
			/>
			<SelectInput
				value={value.alcance}
				onChange={(e) => handler("alcance", e as "cuna_puerta" | "puerta_puerta")}
				errors={errors.alcance}
				label="Alcance"
				// placeholder="Alcance"
				options={{
					cuna_puerta: "De cuna a puerta",
					puerta_puerta: "De puerta a puerta",
				}}
			/>

			<Button variant="secondary" onClick={handleEntrada} className="w-full">Añadir Entrada</Button>
			<Button variant="secondary" onClick={handleSalida} className="w-full">Añadir Salida</Button>
		</form>
	);
}

type ChangeHandler<T> = <K extends keyof z.input<T>>(field: K, val: z.input<T>[K]) => void;